import React from "react";
import { useSelector } from "react-redux";
import { normalizePrice } from "helpers/PricingHelper";

const BuynowPrice = () => {
  const buynowPrice = useSelector(state => state.pdp?.buy?.pricing?.price || []);

  const buynowPriceMap = Object.fromEntries(buynowPrice.map(({ id, value, discount }) => [id, { value, discount }]));
  const buyPrice = buynowPriceMap["buy"]?.value;
  const discount = buynowPriceMap["buy"]?.discount;

  const discountPercent = typeof discount === "number" ? Math.round(discount * 100) : null;

  if (!buyPrice) return null;

  return (
    <p className="mt-1 mb-4 text-darkGray">
      {normalizePrice(buyPrice)} to buy {discountPercent !== null && `(${discountPercent}% off)`}
    </p>
  );
};

export default BuynowPrice;
